module.exports = __webpack_public_path__ + "img/page-15.b76b5476.jpg";